import { dayjsUtils } from '@shared/utils/helpers/dayjs';

export function formatDate(dateString: string) {
  return dayjsUtils(dateString).format('DD MMM YYYY');
}
